var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyMedisBreadcrumbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 14.6666C2.22844 14.6666 1.33301 13.7712 1.33301 12.6666V6.03827C1.33301 5.33574 1.70161 4.68473 2.30402 4.32328L6.97068 1.52328C7.60405 1.14326 8.3953 1.14326 9.02867 1.52328L13.6953 4.32328C14.2977 4.68473 14.6663 5.33574 14.6663 6.03827V12.6666C14.6663 13.7712 13.7709 14.6666 12.6663 14.6666H3.33301ZM13.333 6.03827V12.6666C13.333 13.0348 13.0345 13.3333 12.6663 13.3333H10.6663V10.6666C10.6663 9.93023 10.0694 9.33328 9.33301 9.33328H6.66634C5.92996 9.33328 5.33301 9.93023 5.33301 10.6666V13.3333H3.33301C2.96482 13.3333 2.66634 13.0348 2.66634 12.6666V6.03827C2.66634 5.80409 2.78921 5.58709 2.99001 5.46661L7.65668 2.66661C7.8678 2.53993 8.13155 2.53993 8.34267 2.66661L13.0093 5.4666C13.2101 5.58709 13.333 5.80409 13.333 6.03827ZM6.66634 13.3333H9.33301V10.6666H6.66634V13.3333Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyMedisBreadcrumbs);
export default __webpack_public_path__ + "static/media/iconMyMedisBreadcrumbs.31dd78efa20eee5abf87ca58b7ffb56f.svg";
export { ForwardRef as ReactComponent };